module.exports = __webpack_public_path__ + "img/SoldaFricção.c43da351.jpg";